import React from 'react'

import { GoogleLoginButton } from 'partials/GoogleLoginButton'

import { Box } from 'widgets/Box'
import { Text } from 'widgets/Text'

export const SocialSignIn = () => {
  return (
    <Box align='center' margin={{ top: 'md', left: 'md', right: 'md' }} flexDirection='column'>
      <Box
        testID='SocialSignInInnerContainer'
        width='100%'
        margin='md'
        flexDirection='row'
        justifyContent='center'
        align='center'
      >
        <Box backgroundColor='greyDark' flex={1} height={1} />
        <Box margin={{ horizontal: 'md' }}>
          <Text fontSize='sm' bold color='greyDark' align='center'>
            OR
          </Text>
        </Box>
        <Box backgroundColor='greyDark' flex={1} height={1} />
      </Box>

      <Box testID='WebGoogleLoginButtonContainer' margin='md' width='100%'>
        <GoogleLoginButton />
      </Box>
    </Box>
  )
}
